module.exports = __webpack_public_path__ + "static/media/icon_empty-data.7b6f2b1f.svg";